import { createSlice } from "@reduxjs/toolkit";
import { DealerCareInitialStore } from "./types.store";
import { handleGetDealerCareRequest } from "./thunk.store";

const initialState: DealerCareInitialStore = {
  data: [],
  pagination: {
    limit: 3,
    offset: 0,
    count: 0,
    totalCount: 0,
  },
};

const DealerCareStore = createSlice({
  initialState,
  name: "dealerCareData",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(handleGetDealerCareRequest.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.pagination = action.payload.pagination;
    });
  },
});

export default DealerCareStore.reducer;
